import { schema } from 'normalizr'

import customer from './customer'

export const InvitationSchema = new schema.Entity('invitations', {
  invitedCustomer: customer,
  customer,
})
